import { FILENAME_REGEX } from './regex/filename';

export const getFilenameFromURL = (url: string): string | undefined => {
	const match = FILENAME_REGEX.exec(url);

	return match ? match[0] : undefined;
};
